// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__263JF","header":"PatientBlock_header__3TUGw","label":"PatientBlock_label__2dOy4","option":"PatientBlock_option__3x9pK"};